const Delete = ({ clickHandler }) => {
  return (
    <span className="crop-btn cursor-pointer delete-image">
      <button
        className="close"
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        onClick={clickHandler}
      >
        ×
      </button>
    </span>
  );
};

export default Delete;
